import { 
  FETCHING_DATA, FETCHING_DATA_SUCCESS, FETCHING_DATA_FAILURE, 
  SET_SAYTEXT, SET_IPA_FLAVOUR, 
  RESET_FORM 
} from '../Globals'

/*
 * This file contains the reducers.
 */

const initialState = { text:'', ipa:'', ipaflavour: '', isFetching: false, errText:'' };

const sracan = (s = "") => {
  if (!s) {
    return '';
  }

  return s.replace(/ee/g, 'è')
          .replace(/ii/g, 'ì')
          .replace(/oo/g, 'ò')
          .replace(/uu/g, 'ù')
          .replace(/aa/g, 'à')
          .replace(/EE/g, 'é')
          .replace(/OO/g, 'ó')
}

const g2pdata = (state = initialState, action) => {
  switch (action.type) {
    case SET_SAYTEXT:
      return {
        ...state,
        text: sracan(action.text)
      }
    case SET_IPA_FLAVOUR:
      return {
        ...state,
        ipaflavour: action.ipaflavour
      }
    case RESET_FORM:
      return initialState
    case FETCHING_DATA:
      return {
        ...state,
        errText: ''
      }
    case FETCHING_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errText: '',
        ipa: action.ipa
      }
    case FETCHING_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        errText: action.message
      }
    default:
      return state
  }
}


export default g2pdata




// WEBPACK FOOTER //
// ./src/reducers/g2pdata.js